/**
 * @file: ProductReferralStatus.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ProductReferralStatus {
  AwaitingApproval = 'awaiting_approval',
  PartialApproved = 'partial_approved',
  ApprovalFinished = 'approval_finished',
  PartialResolved = 'partial_resolved',
  Resolved = 'resolved',
}

export const ProductReferralStatusValueSet = new Set([
  ProductReferralStatus.AwaitingApproval,
  ProductReferralStatus.PartialApproved,
  ProductReferralStatus.ApprovalFinished,
  ProductReferralStatus.PartialResolved,
  ProductReferralStatus.Resolved,
]);
